import TileButton from 'components/atoms/TileButton';
import SubFilterCompareIcon from 'components/molecules/GrowthAnalysis/SubFilterCompareIcon';
import SubFilterDropdown from 'components/molecules/GrowthAnalysis/SubFilterDropdown';
import Loader from 'components/molecules/Loader';
import ExpandedView from 'components/template/GrowthAnalysis/ExpandedView';
import CalenderPriceChange from 'components/pages/CalenderPriceChange';
import ErrorBox from 'components/molecules/ErrorBox/ErrorBox';
import dayjs from 'dayjs';
import { colorConstants } from 'config/colorConstants';
import { frequencyDaysMapping } from 'config/constants';
import { UserContext } from 'contexts/ConfigContext';
import { FilterContextData } from 'contexts/FilterContext';
import { useFetchAttributeLevelSales } from 'hooks/growthAnalysis/useFetchAttributeLevelSales';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import {
    generateDefaultApplyFilter,
    getBaseUrl,
    getConfig,
    getKeyByValue,
    parseAttributeType,
} from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    GROWTH_ANALYSIS_ABS_TAB_CHANGED,
    GROWTH_ANALYSIS_COMPARE_CLICKED,
    GROWTH_ANALYSIS_SALES_TAB_CHANGED,
    GROWTH_ANALYSIS_SUB_FILTER_ADDED,
    GROWTH_ANALYSIS_SUB_FILTER_CHANGED,
    GROWTH_ANALYSIS_SUB_FILTER_DESELECTED,
    GROWTH_ANALYSIS_UNIT_DROPDOWN_CHANGED,
} from 'utils/mixpanelEventNames';
import NoDataForSelection from 'components/atoms/NoDataForSelection';
import DownSvg from 'assets/svg/Down';
import styled from '@emotion/styled';
import { Checkbox, Dropdown, Select } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import tw from 'twin.macro';
import { useCommonApiHandler } from 'hooks/general/useCommonApiHandler';
import { useFetchDepletionAttributeLevelSales } from 'hooks/depletion/useFetchDepletionAttributeLevelSales';
import { Urls } from 'config/urls';
import { totalString } from 'parser/attributeSalestableParser';

export const tileSalesDataMapping: any = {
    chartMapping: {
        abs: 0,
        percentage: 1,
    },
    tableMapping: {
        vol: 0,
        val: 1,
        units: 2,
        profit: 3,
    },
};

export const defaultApplyFilter = {
    jsonstring_dim1: {},
    jsonstring_dim2: {},
};

// export const attrTypeOptions = [
//     { label: 'Manufacturer', value: 1 },
//     { label: 'Category', value: 2 },
//     { label: 'Sub Category', value: 3 },
//     { label: 'Brand', value: 4 },
//     { label: 'Sub Brand', value: 5 },
//     { label: 'Pack Size', value: 6 },
//     { label: 'Pack Type', value: 7 },
//     { label: 'PPG', value: 8 },
// ];

export type salesDataType = {
    chartData: any | null;
    tableData: any | null;
    loading: boolean;
    error: any;
    count: number;
};

export const nullAttrTypeOption = { label: null, value: null, dimension: null }; //change this item's data structure according to attrTypeOptions array item

// const dummyVariables = {
//     attributeType: 'category',
//     dimension: 'dim1',
//     filters:
//         '{"dim1":{"ids":[32290,32291,32292,32293,32294,32295,32296,32306,32313,32314,32315,32316,32317,32318,32319,32320,32328,32329,32330,32331,32332,32337,32345,32346,32349,32350,32351,32353,32354,32355,32356,32357,32364,32370,32371,32372,32373,32374,32382,32383,32390,32391,32392,32393,32410,32411,32440,32441,32456,32457,32460,32461,32462,32463,32464,32465,32466,32467,32468,32469,32470,32471,32472,32473,32474,32475,32476,32477,32478,32479,32480,32481,32482,32483,32484,32485,32486,32487,32488,32489,32490,32491,32492,32493,32494,32495,32496,32497,32498,32500,32501,32502,32503,32504,32505,32623,32624,32625,32626,32627,32628,32629,32630,32631,32632,32633,32636,32652,32653,32654,32655,32656,32657,32665,32668,32669,32670,32686,32720,32721,32722,32723,32724,32725,32728,32729,32768,32796,32797,32798,32802,32803,32806,32807,32808,32809,32810,32811,32812,32813,32814,32815,32816,32817,32834,32835,32836,32862,32863,32865,32866,32867,32872,32873,32893,32963,32964,32965,32966,32970,32971,32972,32973,32974,32975,32976,32977,32978,32979,32980,32981,32988,32998,32999,33004,33005,33006,33007,33008,33009,33010,33011,33012,33013,33014,33020,33021,33022,33023,33024,33025,33026,33027,33028,33029,33030,33031,33032,33033,33034,33035,33036,33039,33040,33056,33067,33151,33152,33153,33154,33155,33156,33157,33158,33159,33160,33161,33162,33163,33166,33167,33168,33180,33181,33182,33183,33184,33185,33186,33187,33188,33195,33196,33197,33198,33199,33200,33201,33202,33203,33217,33219,33220,33222,33223,33224,33225,33226,33227,33228,33229,33230,33231,33232,33233,33234,33235,33236,33237,33238,33239,33240,33241,33242,33243,33244,33245,33246,33247,33248,33249,33250,33252,33253,33254,33255,33256,33257,33258,33259,33260,33261,33262,33263,33264,33265,33266,33267,33268,33269,33270,33271,33272,33273,33274,33275,33276,33277,33278,33279,33280,33281,33282,33283,33284,33285,33286,33287,33288,33289,33290,33291,33292,33293,33294,33295,33296,33297,33298,33299,33300,33301,33302,33303,33304,33305,33306,33307,33308,33309,33310,33311,33312,33313,33314,33315,33316,33317,33318,33319,33320,33321,33322,33323,33324,33325,33326,33327,33328,33329,33330,33331,33332,33333,33334,33335,33336,33337,33338,33339,33340,33341,33342,33343,33344,33345,33346,33347,33348,33349,33350,33351,33369,33370,33371,33372,33373,33374,33375,33385,33386,33387,33388,33390,33391,33392,33393,33394,33396,33397,33398,33402,33415,33427,33428,33483,33484,33485,33486,33488,33489,33490,33491,33492,33493,33494,33505,33506,33521,33522,33523,33524,33525,33526,33527,33528,33529,33530,33531,33532,33533,33534,33535,33536,33537,33538,33539,33540,33541,33542,33543,33544,33545,33546,33547,33548,33549,33550,33551,33552,33553,33554,33555,33556,33557,33559,33560,33561,33562,33563,33585,33599,33600,33601,33602,33613,33614,33633,33634,33636,33637,33638,33639,33640,33641,33642,33643,33644,33645,33646,33647,33648,33653,33657,33658,33659,33666,33667,33672,33673,33689,33690,33693,33694,33695,33696,33697,33698,33699,33700,33701,33702,33703,33704,33705,33706,33707,33708,33715,33716,33717,33718,33719,33720,33721,33722,33723,33728,33729,33730,33731,33732,33733,33734,33735,33736,33737,33738,33763,33764,33820,33821,33822,33823,33824,33825,33826,33848,33849,33850,33851,33852,33853,33859,33862,33863,33864,33865,33868,33869,33876,33877,33895,33896,33897,33898,33899,33900,33901,33902,33905,33906,33907,33908,33909,33910,33911,33918,33919,33920,33921,33922,33923,33924,33925,33926,33927,33928,33929,33930,33931,33932,33933,33934,33935,33936,33937,33946,33947,33948,33949,33950,33951,33952,33953,33954,33955,33956,33957,33958,33959,33960,34205,34206,34383,34388,34389,34390,34391,34392,34400,34401,34402,34403,34404,34405,34417,34418,34419,34420,34421,34422,34423,34424,34425,34427,34428,34433,34434,34435,34460,34461,34462,34463,34464,34465,34466,34467,34468,34469,34470,34471,34472,34473,34474,34477,34478,34479,34480,34485,34486,34487,34490,34491,34492,34493,34494,34495,34496,34504,34505,34506,34507,34515,34516,34519,34520,34521,34522,34523,34524,34525,34526,34527,34528,34529,34535,34536,34537,34538,34539,34540,34541,34542,34543,34544,34545,34546,34547,34548,34603,34604,34614,34615,34616,34617,34618,34619,34620,34621,34622,34623,34624,34630,34642,34646,34654,34655,34656,34657,34660,34661,34663,34664,34665,34666,34667,34668,34669,34670,34671,34672,34673,34674,34675,34676,34677,34678,34679,34680,34681,34684,34685,34686,34695,34696,34713,34714,34715,34716,34717,34718,34719,34720,34721,34722,34723,34737,34738,34739,34740,34746,34747,34748,34749,34752,34753,34754,34758,34759,34760,34761,34765,34766,34767,34768,34769,34779,34780,34781,34782,34783,34784,34797,34798,34799,34800,34805,34807,34808,34826,34827,34828,34829,34830,34831,34832,34833,34834,34835,34836,34841,34843,34844,34847,34848,34849,34850,34851,34870,34873,34874,34875,34887,34889,34890,34891,34892,34972,34973,34974,34975,34976,34977,34978,34979,34980,34981,34982,34983,34994,34995,34996,34997,35255,35560,35561,35562,35563,35564,35565,35566,35567,35568,35569,35570,35571,35580,35581,35606,35607,35608,35609,35610,35611,35612,35613,35614,35615,35616,35617,35618,35619,35620,35621,35622,35623,35624,35625,35626,35627,35628,35629,35637,35669,35670,35671,35672,35673,35674,35675,35676,35682,35683,35684,35685,35695,35696,35698,35699,35700,35701,35702,35703,35704,35705,35706,35707,35717,35718,35719,35720,35721,35722,35723,35724,35725,35726,35727,35728,35729,35730,35731,35732,35733,35734,35740,35744,35745,35746,35756,35757,35758,35759,35760,35761,35796,35801,35802,35803,35807,35808,35809,35810,35811,35812,35825,35833,35834,35835,35836,35837,35838,35839,35840,35841,35842,35843,35844,35845,35846,35847,35848,35849,35850,35854,35855,35856,35857,35858,35859,35860,35861,35862,35863,35864,35865,35866,35867,35868,35869,35870,35871,35872,35873,35874,35875,35876,35877,35878,35879,35880,35881,35882,35883,35884,35885,35886,35887,35888,35889,35890,35891,35892,35893,35894,35895,35896,35897,35907,35908,35909,35920,35921,35922,35923,35924,35925,35926,35927,35928,35929,35930,35931,35934,35935,35940,35945,35954,35955,35956,35957,35958,35959,35960,35961,35962,35963,35973,35989,35990,35991,35992,35996,35997,35998,35999,36039,36040,36041,36042,36046,36047,36048,36049,36050,36051,36052,36053,36054,36055,36056,36057,36058,36059,36060,36061,36062,36063,36064,36065,36066,36067,36068,36069,36070,36071,36072,36073,36074,36075,36076,36077,36078,36079,36080,36081,36082,36083,36084,36085,36086,36087,36088,36089,36090,36091,36127,36128,36129,36130,36131,36132,36145,36146,36364,36365,36366,36368,36370,36371,36372,36381,36403,36404,36424,36425,36426,36427,36432,36433,36438,36439,36440,36441,36443,36444,36445,36446,36447,36448,36449,36450,36451,36452,36453,36454,36455,36456,36457,36458,36459,36460,36461,36462,36463,36464,36465,36466,36476,36477,36478,36479,36480,36481,36482,36483,36484,36493,36538,36539,36546,36547,36558,36559,36560,36561,36562,36563,36564,36565,36566,36567,36568,36574,36585,36586,36587,36588,36589,36590,36591,36592,36593,36594,36595,36596,36597,36598,36599,36600,36601,36602,36603,36604,36605,36606,36607,36608,36609,36618,36629,36630,36631,36633,36634,36657,36660,36661,37017,37018,37019,37020,37021,37043,37044,37047,37048,37049,37050,37051,37056,37057,37058,37059,37060,37061,37062,37063,37064,37065,37066,37067,37068,37069,37070,37071,37108,37112,37113,37117,37118,37119,37120,37122,37123,37150,37151,37152,37153,37154,37155,37156,37157,37158,37159,37160,37161,37162,37163,37164,37165,37166,37167,37168,37169,37170,37171,37172,37173,37174,37175,37176,37177,37178,37179,37180,37181,37182,37183,37184,37185,37186,37187,37190,37191,37192,37193,37204,37205,37215,37216,37217,37218,37219,37220,37221,37222,37223,37224,37225,37226,37227,37228,37229,37230,37231,37232,37233,37234,37237,37238,37239,37240,37241,37244,37245,37246,37247,37248,37249,37255,37256,37257,37258,37259,37260,37261,37262,37271,37272,37273,37274,37275,37278,37279,37280,37281,37282,37283,37284,37285,37286,37287,37288,37289,37290,37291,37292,37293,37294,37300,37301,37302,37303,37304,37305,37306,37307,37308,37309,37310,37311,37312,37313,37314,37315,37316,37317,37318,37319,37320,37321,37334,37335,37336,37337,37338,37339,37340,37341,37342,37343,37344,37345,37346,37347,37348,37349,37350,37351,37352,37353,37354,37355,37356,37357,37358,37359,37360,37363,37364,37365,37366,37367,37368,37369,37370,37371,37372,37373,37374,37375,37376,37377,37378,37379,37380,37381,37382,37383,37384,37388,37389,37390,37400,37401,37402,37403,37405,37406,37409,37411,37414,37419,37420,37421,37422,37423,37424,37427,37452,37453,37460,37461,37471,37474,37475,37476,37477,37478,37479,37480,37481,37482,37483,37484,37485,37486,37489,37491,37492,37493,37494,37495,37496,37497,37498,37499,37500,37501,37502,37503,37504,37505,37643,37644,37645,37646,37647,37648,37649,37650,37651,37652,37653,37654,37655,37656,37657,37658,37659,37660,37661,37662,37663,37664,37665,37666,37667,37668,37669,37670,37671,37672,37673,37674,37675,37676,37677,37678,37679,37680,37681,37682,37683,37684,37685,37686,37687,37688,37689,37690,37691,37692,37693,37694,37695,37696,37697,37698,37699,37703,37704,37705,37706,37708,37709,37710,37711,37712,37713,37714,37715,37716,37717,37718,37719,37720,37721,37722,37727,37728,37729,37730,37807,37825,37842,37849,37859,37947,37948,37954,37957,37962,38072,38076,38077,38078,38079,38080,38081,38082,38083,38084,38085,38086,38087,38088,38089,38090,38091,38092,38093,38094,38095,38096,38097,38098,38101,38102,38103,38104,38105,38106,38109,38110,38111,38118,38119,38120,38121,38122,38123,38124,38125,38132,38134,38135,38136,38137,38138,38139,38140,38141,38142,38143,38144,38145,38146,38147,38148,38149,38150,38151,38152,38153,38154,38155,38156,38157,38158,38159,38160,38161,38162,38163,38164,38165,38166,38167,38168,38169,38534,38545,38546,38585,38586,38587,38588,38589,38590,38591,38592,38593,38594,38595,38596,38597,38598,38599,38600,38601,38602,38603,38604,38605,38606,38607,38608,38609,38610,38611,38612,38613,38614,38615,38616,38617,38618,38619,38620,38621,38622,38623,38624,38625,38626,38675,38676,38677,38678,38679,38684,38685,38686,38687,38688,38689,38690,38691,38692,38693,38694,38695,38696,38697,38698,38699,38700,38701,38702,38706,38712,38714,38715,38716,38717,38718,38719,38720,38721,38722,38723,38733,38734,38735,38736,38738,38739,38740,38741,38742,38743,38744,38745,38746,38747,38754,38755,38756,38757,38758,38759,38760,38761,38762,38773,38774,38775,38776,38782,38783,38784,38785,38786,38787,38788,38789,38790,38791,38792,38793,38794,38795,38797,38798,38799,38800,38801,38803,38804,38805,38806,38807,38808,38809,38810,38811,38812,38813,38814,38815,38816,38817,38818,38819,38820,38821,38822,38827,38828,38830,38831,38832,38833,38834,38835,38836,38842,38843,38844,38863,38867,38868,38889,38890,38911,38913,38914,38915,38916,38917,38918,38919,38926,38927,38928,38929,38930,38934,38935,38936,38937,38938,38939,38940,38941,38942,38943,38944,38945,38946,38948,38949,38950,38956,38957,38958,38959,38960,38961,38962,38963,38964,38965,38966,38967,38968,38969,38970,38971,38972,38973,38974,38975,38976,38977,38978,38979,38980,38981,38982,38983,38984,38985,38986,38987,38988,38989,38990,38991,38992,38993,38994,38995,38996,38997,38998,38999,39000,39001,39002,39003,39014,39024,39025,39035,39036,39038,39044,39051,39052,39053,39054,39089,39090,39091,39092,39093,39094,39098,39101,39102,39170,39173,39181,39182,39189,39190,39191,39192,39193,39194,39201,39216,39217,39226,39227,39228,39229,39231,39232,39237,39238,39239,39240,39247,39248,39249,39258,39259,39260,39261,39262,39263,39264,39265,39266,39267,39268,39270,39271,39272,39273,39274,39275,39276,39284,39285,39288,39289,39290,39291,39292,39293,39294,39296,39297,39298,39299,39300,39301,39313,39314,39321,39322,39352,39353,39354,39355,39356,39357,39358,39359,39360,39361,39362,39363,39364,39365,39366,39367,39368,39369,39370,39371,39372,39373,39374,39375,39376,39377,39378,39379,39380,39381,39382,39383,39384,39385,39386,39387,39390,39394,39395,39396,39397,39398,39399,39401,39402,39403,39404,39407,39409,39410,39411,39417,39418,39419,39420,39421,39422,39423,39424,39425,39426,39427,39428,39430,39431,39433,39434,39435,39436,39437,39438,39439,39440,39441,39442,39443,39446,39447,39448,39449,39450,39451,39461,39462,39463,39477,39478,39479,39480,39481,39482,39483,39484,39485,39486,39516,39517,39518,39519,39520,39521,39522,39525,39527,39530,39532,39533,39534,39553,39554,39555,39556,39557,39558,39559,39560,39561,39562,39563,39564,39565,39566,39567,39568,39569,39570,39571,39572,39573,39574,39575,39576,39586,39587,39588,39589,39590,39591,39592,39593,39594,39595,39596,39597,39598,39599,39600,39601,39602,39603,39604,39612,39613,39614,39615,39616,39617,39622,39623,39629,39630,39636,39640,39644,39650,39651,39652,39653,39679,39700,39714,39715,39733,39744,39748,39749,39750,39751,39752,39753,39755,39760,39761,39764,39765,39766,39767,39768,39769,39770,39771,39772,39773,39774,39775,39776,39777,39778,39779,39780,39781,39782,39783,39784,39785,39786,39787,39788,39789,39790,39791,39792,39793,39794,39795,39796,39801,39817,39820,39821,39900,39909,39911,39928,39930,39948,39963]},"dim2":{"ids":[320,323,326,329,332,335,338,340,355,364,370,382,386,396,411,426,436,442,447,453,462,465,471,480,490,493,498,508,514,517,520,523,526,533,539,542,545,549,552,568,571,574,577,580,583,586,589,590,596,602,604,610,621,631,634,637,639,645,650,659,662,671,674,677,679,683,686,689,692,697,699,700,707,712,718,721,724,740,743,749]}}',
//     timePeriod: '52w',
//     lagList: [0, 1],
//     limit: 20,
//     offset: 0,
// };
export type salesTileKeyType = 'sales' | 'incremental' | 'promo' | 'depletion';

export type salesTileItemType = {
    key: salesTileKeyType;
    label: string;
};

export const CustomSelect = styled(Select)`
    ${tw`border border-purpleFont rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
`;
export type from = 'depletion' | 'growth-analysis' | 'shipment-growth-analysis';
type Props = {
    from: from;
};

const GrowthAnalysis = ({ from = 'growth-analysis' }: Props) => {
    const { appConfig } = useContext(UserContext);
    const growthAnalysisConfig = getConfig('growthAnalysis', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const globalFilterConfig = getConfig('globalFilter', appConfig);
    const replacementKeyMapping = globalFilterConfig?.replacementKeyMapping;
    const {
        salesTileData,
        absTileData,
        volTileData,
        depletionDropdownData,
        depletionTileData,
        includeAggPeriod,
        timePeriodOptions,
        dimensionConfig: { defaultDimension, excludedDimensions },
        showTotal,
    } = growthAnalysisConfig;
    const comparePeriodEnabled = from === 'growth-analysis' && Boolean(timePeriodOptions?.length);
    const baseLinePeriodLabel = 'Compare Period';
    const [selectedTimePeriodDropdown, setSelectedTimePeriodDropdown] = useState<any>(timePeriodOptions?.[0]);
    const [secondStartRange, setSecondStartRange] = useState('');
    const [secondEndRange, setSecondEndRange] = useState('');
    const [absTile, setAbsTile] = useState(absTileData[0]);
    const isDepletion = from === 'depletion';
    const [volTile, setVolTile] = useState(isDepletion ? depletionDropdownData[0] : volTileData[0]);
    const [salesTile, setSalesTile] = useState(isDepletion ? depletionTileData : salesTileData[0]);
    const [attrTypeOptions, setAttrOptions] = useState({ data: [], loading: false });
    const [subFilterSelectedItems, setSubFilterSelectedItems] = useState([{ ...nullAttrTypeOption }]);
    const [activeCompareIcons, setActiveCompareIcons] = useState<any[]>([]);
    const [attributeTypeToShow, setAttributeTypesToShow] = useState<any[]>([]);
    const [reactQueryVariables1, setReactQueryVariables1] = useState<any>();
    const [reactQueryVariables2, setReactQueryVariables2] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [showTotals, setShowTotals] = useState<boolean>(showTotal ?? true);
    const effectiveShowTotals = isDepletion ? showTotal : showTotals;
    const offsetRef = useRef({
        offset: [commonConfig.offset || 0, commonConfig.offset || 0],
        width: [0, 0],
    });
    const previousVolTileRef = useRef(volTile);
    const lastItemInHierarchy = useRef<any>({
        dim1: null,
        dim2: null,
        dim3: null,
    });
    const previousAppliedGlobalFilter = useRef<any>({
        filter: [],
        labels: [],
        previousSelectedItem: [],
    });
    const appliedGlobalFilter = useRef<string>('');
    const applyFilterObj = useRef<any>(null);

    const {
        filterNullError,
        allDimAndAttributeTypeList,
        idForRestOfComponent,
        timePeriodLoading,
        timePeriodSelection,
        timeSelectionLabel,
        screenFilterConfig,
        idForRestOfComponentLoading,
        currentFrequency,
    } = useContext(FilterContextData);

    const isCustomDateSelectedInGlobalFilter = String(timeSelectionLabel)?.toLowerCase() === 'custom date';
    const comparePeriodOptions = useMemo(() => {
        if (!comparePeriodEnabled || !timePeriodOptions.length) return [];
        return isCustomDateSelectedInGlobalFilter
            ? timePeriodOptions
            : timePeriodOptions.filter((val: any) => val.value !== 'custom');
    }, [comparePeriodEnabled, isCustomDateSelectedInGlobalFilter]);

    useEffect(() => {
        if (!isCustomDateSelectedInGlobalFilter && selectedTimePeriodDropdown?.value === 'custom') {
            setSelectedTimePeriodDropdown(timePeriodOptions?.[0]);
            setSecondStartRange('');
            setSecondEndRange('');
        }
    }, [isCustomDateSelectedInGlobalFilter]);

    /** Span of the current global time window (seconds); used to auto-set compare end from compare start only. */
    const comparePeriodDurationSeconds = useMemo(() => {
        try {
            if (timePeriodSelection == null || timePeriodSelection === '') return 0;
            const parsed =
                typeof timePeriodSelection === 'string' ? JSON.parse(timePeriodSelection) : timePeriodSelection;
            const start = Number(parsed?.start_timestamp);
            const end = Number(parsed?.end_timestamp);
            if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 0;
            return end - start;
        } catch {
            return 0;
        }
    }, [timePeriodSelection]);

    const useDerivedCompareCustomEnd =
        comparePeriodEnabled &&
        selectedTimePeriodDropdown?.value === 'custom' &&
        comparePeriodDurationSeconds > 0 &&
        isCustomDateSelectedInGlobalFilter;

    useEffect(() => {
        if (!useDerivedCompareCustomEnd) return;
        if (!secondStartRange) {
            setSecondEndRange('');
            return;
        }
        const start = dayjs(secondStartRange, commonConfig.dateFormat);
        if (!start.isValid()) return;
        setSecondEndRange(start.add(comparePeriodDurationSeconds, 'second').format(commonConfig.dateFormat));
    }, [useDerivedCompareCustomEnd, comparePeriodDurationSeconds, secondStartRange, commonConfig.dateFormat]);

    useEffect(() => {
        if (
            allDimAndAttributeTypeList &&
            'loading' in allDimAndAttributeTypeList &&
            !allDimAndAttributeTypeList['loading'] &&
            allDimAndAttributeTypeList['dimentions']
        ) {
            const data = parseAttributeType(allDimAndAttributeTypeList['dimentions'], excludedDimensions);
            if (data.length) {
                setAttrOptions({ ...attrTypeOptions, data });
                if (subFilterSelectedItems?.length === 1)
                    setSubFilterSelectedItems([
                        data.find((item: any) => item.label === defaultDimension) || data[0],
                        ...subFilterSelectedItems,
                    ]);
            }
        }

        //cleanup
        //reset states to default
        return () => {
            setAttrOptions({ data: [], loading: false });
            setSubFilterSelectedItems([{ ...nullAttrTypeOption }]);
            setActiveCompareIcons([]);
        };
    }, [allDimAndAttributeTypeList?.loading]);

    const stringifiedGlobalFilter = useMemo(() => {
        const stringifiedGlobalFilter = JSON.stringify(idForRestOfComponent);
        //resetting apply filter object
        resetApplyFilterObj(stringifiedGlobalFilter, true);
        return stringifiedGlobalFilter;
    }, [idForRestOfComponent]);

    // Baseline unix range for compare (custom calendar)
    const baselineTimePeriod = useMemo(() => {
        if (!comparePeriodEnabled) {
            return { start_timestamp: 0, end_timestamp: 0 };
        }
        const daysDifference = frequencyDaysMapping[currentFrequency?.key ?? 'W'] ?? 0;
        const dayjsStartDate = dayjs(secondStartRange, commonConfig?.dateFormat);
        const dayjsEndDate = dayjs(secondEndRange, commonConfig?.dateFormat);
        const utcOffsetStartDate = dayjs(dayjsStartDate).utcOffset();
        const utcOffsetEndDate = dayjs(dayjsEndDate).utcOffset();
        const startDateUnix = dayjsStartDate
            .add(utcOffsetStartDate, 'm')
            .utc()
            .subtract(daysDifference, 'day')
            .startOf('day')
            .unix();
        const endDateUnix = dayjsEndDate
            .add(utcOffsetEndDate, 'm')
            .utc()
            .subtract(daysDifference, 'day')
            .startOf('day')
            .unix();
        return {
            start_timestamp: startDateUnix,
            end_timestamp: endDateUnix,
        };
    }, [comparePeriodEnabled, secondStartRange, secondEndRange, currentFrequency?.key, commonConfig?.dateFormat]);

    //variables for attribute sales query
    const variables = useMemo(() => {
        const tempObj: Record<string, any> = {
            limit: growthAnalysisConfig.limit,
            offset: commonConfig.offset,
            lagList: commonConfig.lagList,
            timePeriod: String(timePeriodSelection).toLowerCase(),
            frequency: currentFrequency?.key,
            aggPeriod:
                comparePeriodEnabled || !includeAggPeriod
                    ? ''
                    : String(timeSelectionLabel)?.toLowerCase() === 'custom date' ||
                      String(timeSelectionLabel)?.toLowerCase() === 'ytd'
                    ? ''
                    : getKeyByValue(replacementKeyMapping, String(timeSelectionLabel)?.toUpperCase()),
            filters: stringifiedGlobalFilter,
            featureName: screenFilterConfig?.dimensionListKey ?? 'default',
        };
        if (comparePeriodEnabled) {
            // If the global filter has already left "custom date" but the compare dropdown
            // hasn't been reset yet, treat it as the first non-custom option so variables
            // are always correct on the first render after a global filter change.
            const isCompareDropdownPendingReset =
                !isCustomDateSelectedInGlobalFilter && selectedTimePeriodDropdown?.value === 'custom';
            tempObj.comparisonPeriodType = isCompareDropdownPendingReset
                ? timePeriodOptions?.[0]?.value
                : selectedTimePeriodDropdown?.value;
            // Only pass real baseline dates for the custom compare type; for year_ago /
            const useCustomBaseline =
                selectedTimePeriodDropdown?.value === 'custom' && isCustomDateSelectedInGlobalFilter;
            tempObj.timePeriod = [
                timePeriodSelection,
                JSON.stringify(useCustomBaseline ? baselineTimePeriod : { start_timestamp: null, end_timestamp: null }),
            ];
        }
        return tempObj;
    }, [
        stringifiedGlobalFilter,
        screenFilterConfig,
        timePeriodSelection,
        currentFrequency?.key,
        comparePeriodEnabled,
        isCustomDateSelectedInGlobalFilter,
        selectedTimePeriodDropdown?.value,
        baselineTimePeriod,
    ]);

    const {
        data: applyFilterData,
        loading: applyFilterLoading,
        error: applyFilterError,
        applyFilterMutate,
    } = useApplyFilterMutation({ onComplete: onApplyFilterComplete });

    const {
        data: firstLevelSalesData,
        loading: firstLevelSaleLoading,
        error: firstLevelSaleError,
        count: firstLevelSaleCount,
        comparisonTimePeriod,
        fetchAttributeLevelSales: fetchFirstLevelSales,
    } = useFetchAttributeLevelSales({ salesTile, selectedTimePeriodDropdownValue: selectedTimePeriodDropdown?.value });

    const {
        data: secondLevelSalesData,
        loading: secondLevelSaleLoading,
        error: secondLevelSaleError,
        count: secondLevelSaleCount,
        fetchAttributeLevelSales: fetchSecondLevelSales,
    } = useFetchAttributeLevelSales({ salesTile, selectedTimePeriodDropdownValue: selectedTimePeriodDropdown?.value });

    //depletion data chart 1
    const {
        data: depletionFirstData,
        loading: depletionFirstLoading,
        error: depletionFirstError,
        count: depletionFirstCount,
    } = useFetchDepletionAttributeLevelSales({
        method: 'post',
        queryConfig: { enabled: isDepletion && Boolean(reactQueryVariables1) },
        queryKey: ['depletion-bar-chart-1', reactQueryVariables1],
        url: `${getBaseUrl()}${Urls.depletionBarChartUrl}`,
        variables: {
            ...reactQueryVariables1,
        },
        extras: {
            ...reactQueryVariables1,
            volTile,
        },
    });

    //depletion data chart 2

    const {
        data: depletionSecondData,
        loading: depletionSecondLoading,
        error: depletionSecondError,
        count: depletionSecondCount,
    } = useFetchDepletionAttributeLevelSales({
        method: 'post',
        queryConfig: { enabled: isDepletion && Boolean(reactQueryVariables2) },
        queryKey: ['depletion-bar-chart-2', reactQueryVariables2],
        url: `${getBaseUrl()}${Urls.depletionBarChartUrl}`,
        variables: {
            ...reactQueryVariables2,
        },
        extras: {
            ...reactQueryVariables2,
            volTile,
        },
    });

    const memoisedData = useMemo(() => {
        return {
            firstLevelSalesData: isDepletion ? depletionFirstData : firstLevelSalesData,
            secondLevelSalesData: isDepletion ? depletionSecondData : secondLevelSalesData,
            firstLevelSaleLoading: isDepletion ? depletionFirstLoading : firstLevelSaleLoading,
            secondLevelSaleLoading: isDepletion ? depletionSecondLoading : secondLevelSaleLoading,
            firstLevelSaleError: isDepletion ? depletionFirstError : firstLevelSaleError,
            secondLevelSaleError: isDepletion ? depletionSecondError : secondLevelSaleError,
            firstLevelSaleCount: isDepletion ? depletionFirstCount : firstLevelSaleCount,
            secondLevelSaleCount: isDepletion ? depletionSecondCount : secondLevelSaleCount,
        };
    }, [
        isDepletion,
        depletionFirstData,
        firstLevelSalesData,
        secondLevelSalesData,
        depletionSecondData,
        depletionFirstLoading,
        firstLevelSaleLoading,
        depletionSecondLoading,
        secondLevelSaleLoading,
        depletionFirstError,
        firstLevelSaleError,
        depletionSecondError,
        secondLevelSaleError,
        depletionFirstCount,
        firstLevelSaleCount,
        depletionSecondCount,
        secondLevelSaleCount,
    ]);

    const checkIfNullAttributePresent = (arr: any[]) => {
        let nullExists = false;
        for (let i = 0; i < arr.length; i++) {
            if (!arr[i].value) nullExists = true;
        }
        return nullExists;
    };

    //called when clicked on compare icon
    const compareSubFilterClickHandler = (index: number, active: boolean) => {
        localStorage.setItem('compare_clicked', 'true');
        const tempActiveComparison = [...activeCompareIcons];
        if (!active) {
            // tempActiveComparison.push(index); //keep multiple active comparisons at a time
            tempActiveComparison[0] = index; //only keep 1 active comparison icon at a time
        } else {
            removeComparisonActiveItem(index, tempActiveComparison);
        }
        //resetting apply filter object
        resetApplyFilterObj();
        //for promo and incremental change sales tile to 1st item
        if (['promo', 'incremental'].includes(salesTile?.key)) setSalesTile(salesTileData[0]);
        setActiveCompareIcons(tempActiveComparison);
    };

    const removeComparisonActiveItem = (index: number, arr: any[]) => {
        const idx = arr.indexOf(index);
        if (idx > -1) arr.splice(idx, 1);
    };

    function removePreviousFilter() {
        if (activeCompareIcons.length) {
            resetApplyFilterObj();
        }
        appliedGlobalFilter.current = previousAppliedGlobalFilter.current.filter?.pop();
        previousAppliedGlobalFilter.current.labels?.pop();
        applyFilterObj.current = previousAppliedGlobalFilter.current.previousSelectedItem?.pop();
    }

    //sub filter options change/ reset icon click
    const onSubFilterOptionsChange = (val: any, item: any, index: number, filter?: any) => {
        const temp = [...subFilterSelectedItems];
        //if no item and val, it means event is triggered from clear icon
        if (!item && !val) {
            //if clearing last item and drilldown present
            if (index === subFilterSelectedItems.length - 2 && previousAppliedGlobalFilter.current.filter.length) {
                // subtracting 2 to remove null item and considering index here
                //if drilldown present then remove previous drilldown item
                removePreviousFilter();
            } //resetting apply filter object
            else resetApplyFilterObj(filter);
            const removedItem = temp[index];
            //mixpanel event
            trackEventMixpanel(GROWTH_ANALYSIS_SUB_FILTER_DESELECTED, {
                dimension: removedItem?.dimension,
                attributeType: removedItem?.label,
            });
            temp.splice(index, 1); //remove item if cleared
            const tempActiveComparison = [...activeCompareIcons];
            removeComparisonActiveItem(index, tempActiveComparison); //remove comparison icon also on clearing sub filter
            if (index > 0) removeComparisonActiveItem(index - 1, tempActiveComparison); //remove both left and right side comparisons
            if (tempActiveComparison.includes(index + 1))
                tempActiveComparison.splice(tempActiveComparison.indexOf(index + 1), 1, index); //update the compare value
            setActiveCompareIcons(tempActiveComparison);
            const isNullPresent = checkIfNullAttributePresent(temp);
            if (!isNullPresent && temp.length < attrTypeOptions.data?.length) temp.push(nullAttrTypeOption); //add a new null sub filter if no null sub filter exists and its within the limit
        } else {
            //checking if existing attribute is changed
            if (index < temp.length - 1) {
                //changed
                trackEventMixpanel(GROWTH_ANALYSIS_SUB_FILTER_CHANGED, {
                    dimension: item?.dimension,
                    attributeType: item?.label,
                });
            } else {
                //new added
                trackEventMixpanel(GROWTH_ANALYSIS_SUB_FILTER_ADDED, {
                    dimension: item?.dimension,
                    attributeType: item?.label,
                });
            }
            //resetting apply filter object if there is no drilldown present or
            //if drilldown present and changing sub filters except the last subfilter dropdown, reset the apply filter object
            if (
                !previousAppliedGlobalFilter.current.filter.length ||
                (index < subFilterSelectedItems.length - 2 &&
                    !filter &&
                    previousAppliedGlobalFilter.current.filter.length)
            )
                resetApplyFilterObj(filter);

            temp.splice(index, 1, item); //replace item if changed
            if (temp.length < attrTypeOptions.data?.length && temp.length - 1 === index) temp.push(nullAttrTypeOption); //add a new null sub filter if its within the limit
        }

        setSubFilterSelectedItems(temp);
    };

    //bar chart right click handler
    const barChartRightClickHandler = useCallback(
        (item: any, index: number, applyFilterObject: any) => {
            previousAppliedGlobalFilter.current?.filter?.push(appliedGlobalFilter.current);
            previousAppliedGlobalFilter.current?.labels?.push(applyFilterObject?.attributeExId);
            previousAppliedGlobalFilter.current?.previousSelectedItem?.push(applyFilterObj.current);
            setLoading(true);
            onSubFilterOptionsChange(item.value, item, index, appliedGlobalFilter.current);
            applyFilterObj.current = applyFilterObject;
        },
        [variables, attributeTypeToShow],
    );

    //update the options depending on the selected sub filter
    const memoisedSubFilterDropdownOptions = useMemo(() => {
        const tempOptions: any[] = _.cloneDeep(attrTypeOptions.data);
        subFilterSelectedItems.forEach((item) => {
            const attrTypeIndex = tempOptions.findIndex((elem: any) => elem.label === item?.label);
            if (attrTypeIndex > -1) tempOptions.splice(attrTypeIndex, 1);
        });
        if (tempOptions?.length > 0) {
            const dim3LastItemIndex = _.findLastIndex(tempOptions, (item) => item.dimension === 'dim3');
            lastItemInHierarchy.current.dim1 =
                tempOptions[_.findLastIndex(tempOptions, (item) => item.dimension === 'dim1')] || null;
            lastItemInHierarchy.current.dim2 =
                tempOptions[_.findLastIndex(tempOptions, (item) => item.dimension === 'dim2')] || null;
            lastItemInHierarchy.current.dim3 = dim3LastItemIndex === -1 ? null : tempOptions[dim3LastItemIndex];
        } //always store the last item in hierarchy for different dimensions
        return tempOptions;
    }, [subFilterSelectedItems, attrTypeOptions]);

    const arrangeAttrType = (index: number) => {
        return [
            formatAttrTypeItems(subFilterSelectedItems[index]),
            formatAttrTypeItems(subFilterSelectedItems[index + 1]),
        ];
    };

    //attribute sales data
    const salesDataset = useMemo(() => {
        const {
            firstLevelSaleCount,
            firstLevelSaleError,
            firstLevelSaleLoading,
            firstLevelSalesData,
            secondLevelSaleCount,
            secondLevelSaleError,
            secondLevelSaleLoading,
            secondLevelSalesData,
        } = memoisedData;
        let requiredFirstData: any = { loading: firstLevelSaleLoading || idForRestOfComponentLoading };
        let requiredSecondData: any = { loading: secondLevelSaleLoading || idForRestOfComponentLoading };
        const otherLoadingStates = applyFilterLoading || loading;
        if (otherLoadingStates) {
            //if only 1 attribute type is being shown ,change load of state of 1st attribute type
            if (attributeTypeToShow.length === 1) requiredFirstData.loading = otherLoadingStates;
            //else, change load of state of 2nd attribute type (in comparison mode)
            else {
                requiredSecondData.loading = otherLoadingStates;
            }
        }
        //mapping out the data based on volume tile and absolute tile
        if (firstLevelSalesData && 'chartData' in firstLevelSalesData && firstLevelSalesData.chartData.length > 0) {
            const chartData = firstLevelSalesData.chartData[tileSalesDataMapping['chartMapping'][`${absTile.key}`]];
            if (!showTotals && !isDepletion) {
                let minVal = Infinity,
                    maxVal = -Infinity;
                const filteredData = chartData.data.filter((item: any) => {
                    if (item.category?.trim() === totalString.trim()) return false;
                    minVal = Math.min(minVal, item.sales);
                    maxVal = Math.max(maxVal, item.sales);
                    return true;
                });
                requiredFirstData.chartData = { ...chartData, data: filteredData, minVal, maxVal };
            } else {
                requiredFirstData.chartData = chartData;
            }
            requiredFirstData.tableData = firstLevelSalesData.tableData;
        }
        //mapping out the data based on volume tile and absolute tile
        if (secondLevelSalesData && 'chartData' in secondLevelSalesData && secondLevelSalesData.chartData.length > 0) {
            const secondChartData =
                secondLevelSalesData.chartData[tileSalesDataMapping['chartMapping'][`${absTile.key}`]];
            if (!showTotals && !isDepletion) {
                let minVal = Infinity,
                    maxVal = -Infinity;
                const filteredData = secondChartData.data.filter((item: any) => {
                    if (item.category?.trim() === totalString.trim()) return false;
                    minVal = Math.min(minVal, item.sales);
                    maxVal = Math.max(maxVal, item.sales);
                    return true;
                });
                requiredSecondData.chartData = { ...secondChartData, data: filteredData, minVal, maxVal };
            } else {
                requiredSecondData.chartData = secondChartData;
            }
            requiredSecondData.tableData = secondLevelSalesData.tableData;
        }
        const data: salesDataType[] = [
            {
                chartData: requiredFirstData?.chartData || null,
                tableData: requiredFirstData?.tableData || null,
                error: firstLevelSaleError,
                loading: requiredFirstData.loading,
                count: firstLevelSaleCount,
            },
            {
                chartData: requiredSecondData?.chartData || null,
                tableData: requiredSecondData?.tableData || null,
                error: secondLevelSaleError,
                loading: requiredSecondData.loading,
                count: secondLevelSaleCount,
            },
        ];

        return data;
    }, [
        memoisedData?.firstLevelSaleError,
        memoisedData?.firstLevelSaleLoading,
        memoisedData?.firstLevelSalesData,
        memoisedData?.secondLevelSaleError,
        memoisedData?.secondLevelSaleLoading,
        memoisedData?.secondLevelSalesData,
        absTile,
        volTile,
        loading,
        applyFilterLoading,
        memoisedData?.firstLevelSaleCount,
        memoisedData?.secondLevelSaleCount,
        idForRestOfComponentLoading,
        showTotals,
    ]);

    const formatAttrTypeItems = (item: any) => {
        return {
            selectedAttributeType: item.label,
            selectedAttributeValue: item.value,
            selectedAttributeKey: item.key,
            dimension: item.dimension,
            dataset: [],
            disableHover:
                lastItemInHierarchy?.current[item.dimension] === null
                    ? true
                    : lastItemInHierarchy?.current?.[item.dimension]?.value <= item.value, //disable hover in bar chart for last item
            key: Math.random() + item.label, //adding a random key here so that the item gets re-rendered again
        };
    };

    useEffect(() => {
        resetInfiniteScroller();
        //if comparison available, compare scenarios and show all scenarios user has compared
        if (activeCompareIcons.length > 0) {
            const sortedActiveComparisons = [...activeCompareIcons];
            sortedActiveComparisons.sort((a, b) => a - b); //sort active comparison indices in ascending order
            let tempAttrTypeToShow: any[] = [];

            for (let i = 0; i < sortedActiveComparisons.length; i++) {
                tempAttrTypeToShow.push(...arrangeAttrType(sortedActiveComparisons[i]));
            }
            tempAttrTypeToShow = _.uniqBy(tempAttrTypeToShow, (e) => e.selectedAttributeValue); //remove duplicate sub filter items
            setAttributeTypesToShow(tempAttrTypeToShow);

            if (localStorage.getItem('compare_clicked')) {
                //mixpanel event
                trackEventMixpanel(GROWTH_ANALYSIS_COMPARE_CLICKED, {
                    index: Number(sortedActiveComparisons[0]) + 1,
                    firstAttributeType: tempAttrTypeToShow[0]?.selectedAttributeType,
                    secondAttributeType: tempAttrTypeToShow[1]?.selectedAttributeType,
                    isActive: true,
                });
                localStorage.removeItem('compare_clicked');
            }

            //else if atleast 1 subFilter selected, only show latest sub filter selection
        } else if (subFilterSelectedItems?.length > 1) {
            if (localStorage.getItem('compare_clicked')) {
                //mixpanel event
                trackEventMixpanel(GROWTH_ANALYSIS_COMPARE_CLICKED, {
                    index: null,
                    firstAttributeType: null,
                    secondAttributeType: null,
                    isActive: false,
                });
                localStorage.removeItem('compare_clicked');
            }
            for (let i = subFilterSelectedItems.length - 1; i >= 0; i--) {
                //finding the latest sub filter selection
                if (subFilterSelectedItems[i]?.value !== null)
                    return setAttributeTypesToShow([formatAttrTypeItems(subFilterSelectedItems[i])]);
            }
            //else dont show anything
        } else {
            setAttributeTypesToShow([]);
        }
    }, [activeCompareIcons, subFilterSelectedItems]);

    //main header
    const growthAnalysisHeader = useMemo(() => {
        const headerArray = attributeTypeToShow.map((item) => item?.selectedAttributeType);
        return headerArray.join(' vs ');
    }, [attributeTypeToShow]);

    //util function for calling query
    const fetchSalesData = (variables: any, fn: Function) => {
        //for depletion tab using react query
        if (from !== 'depletion') {
            fn({ variables });
        }
    };
    //parsing variables for each attribute type selected in subfilter
    function parseVariables(
        attributeType: any,
        filters: null | string = null,
        offset: number | null = null,
        tileKey: string | number | null = null,
    ) {
        const tempObj: any = {
            ...variables,
            // limit: 20,
            offset: offset === null ? variables.offset : offset,
            //offset: ,
            filters: filters ? filters : variables.filters,
            attributeType: attributeType.selectedAttributeKey,
            dimension: attributeType.dimension,
            fromTab: tileKey ? tileKey : salesTile.key,
            metricType: volTile.dataKey,
            volTile: volTile,
        };
        return tempObj;
    }

    //util function to update variables and execute query
    function updateVariablesAndExecuteQuery(
        item: any,
        fn: Function,
        filters: null | string = null,
        offset: number | null = null,
        tileKey: string | number | null = null,
    ) {
        const updatedVariables = parseVariables(item, filters, offset, tileKey);

        //converting strings to json (filter and time period)
        if (isDepletion) {
            const commonVariables = {
                // start_timestamp: '1676851200',
                // end_timestamp: '1707696000',
                feature_name: from,
                lag_list: updatedVariables.lagList,
                attribute_type: updatedVariables.attributeType,
                dimension: updatedVariables.dimension,
                data_type: updatedVariables.metricType,
                time_period: JSON.parse(updatedVariables.timePeriod),
                filters: JSON.parse(updatedVariables.filters),
                limit: updatedVariables.limit,
                offset: updatedVariables.offset,
                agg_period: updatedVariables.aggPeriod,
            };
            if (fn === fetchFirstLevelSales) {
                setReactQueryVariables1({
                    ...commonVariables,
                });
            } else {
                setReactQueryVariables2({
                    ...commonVariables,
                });
            }
        }
        fetchSalesData(updatedVariables, fn);
    }

    //wrapper function to fetch attribute sales data
    const fetchAllSalesData = useCallback(() => {
        //resetting to default
        resetInfiniteScroller();
        if (applyFilterObj.current) {
            //apply filter call
            prepareApplyFilterVariableAndExecute();
        } else {
            // call attribute sales api once
            if (attributeTypeToShow.length === 1) {
                updateVariablesAndExecuteQuery(attributeTypeToShow[0], fetchFirstLevelSales, undefined, 0);
                // call attribute sales api for different attribute types (max 2)
            } else if (attributeTypeToShow.length === 2) {
                updateVariablesAndExecuteQuery(attributeTypeToShow[0], fetchFirstLevelSales, undefined, 0);
                updateVariablesAndExecuteQuery(attributeTypeToShow[1], fetchSecondLevelSales, undefined, 0);
            }
        }
    }, [attributeTypeToShow, fetchFirstLevelSales, fetchSecondLevelSales, variables]);

    //called when infinite scroll happens with apply filter
    const infiniteScrollerApplyFilterOnNext = (filter: string, index: number) => {
        if (index === 0) {
            return updateVariablesAndExecuteQuery(
                attributeTypeToShow[0],
                fetchFirstLevelSales,
                filter,
                offsetRef.current.offset[index],
            );
        } else {
            {
                return updateVariablesAndExecuteQuery(
                    attributeTypeToShow[1],
                    fetchSecondLevelSales,
                    filter,
                    offsetRef.current.offset[index],
                );
            }
        }
    };

    //reset infinite scroller ref variable
    function resetInfiniteScroller() {
        offsetRef.current.offset = [commonConfig.offset || 0, commonConfig.offset || 0];
        offsetRef.current.width = [0, 0];
    }

    function resetApplyFilterObj(filter?: string, clearPreviousFilter: boolean = false) {
        applyFilterObj.current = null;
        appliedGlobalFilter.current = filter ? filter : stringifiedGlobalFilter;
        if (!filter || clearPreviousFilter)
            previousAppliedGlobalFilter.current = {
                filter: [],
                labels: [],
                previousSelectedItem: [],
            };
    }

    //called when user infinite scrolls
    const infiniteScrollerOnNext = useCallback(
        (index: number, width: number) => {
            offsetRef.current.width[index] = width;
            const newOffsetFirst = offsetRef.current.offset[0] + growthAnalysisConfig.limit;
            const newOffsetSecond = offsetRef.current.offset[1] + growthAnalysisConfig.limit;
            if (index === 0) offsetRef.current.offset[0] = newOffsetFirst;
            if (index === 1) offsetRef.current.offset[1] = newOffsetSecond;
            // if (applyFilterObj.current && index !== 0) {
            //     //apply filter call
            //     return prepareApplyFilterVariableAndExecute();
            // }
            if (index === 0) {
                return updateVariablesAndExecuteQuery(
                    attributeTypeToShow[0],
                    fetchFirstLevelSales,
                    attributeTypeToShow.length === 1 ? appliedGlobalFilter.current : undefined, //if attributestoshow is 2 it means 1st attribute should always use default global filter selection
                    newOffsetFirst,
                    salesTile.key,
                );
            }

            if (index === 1)
                return updateVariablesAndExecuteQuery(
                    attributeTypeToShow[1],
                    fetchSecondLevelSales,
                    appliedGlobalFilter.current,
                    newOffsetSecond,
                    salesTile.key,
                );
        },
        [attributeTypeToShow, salesTile, volTile, variables],
    );

    //called when clicked on item drill down in bar chart
    const drillDownHandler = useCallback(
        (item: any, index: number, applyFilterObject: any) => {
            //if equal then undo action
            //this will only happen in comparison mode
            if (_.isEqual(applyFilterObj.current, applyFilterObject)) {
                //resetting apply filter object
                resetApplyFilterObj();
                resetInfiniteScroller();
                updateVariablesAndExecuteQuery(attributeTypeToShow[1], fetchSecondLevelSales);
                return;
            }
            setLoading(true);
            const tempAttributeIndex = memoisedSubFilterDropdownOptions.findIndex(
                (option: any) => option.value > item.value,
            );
            if (
                tempAttributeIndex > -1 &&
                checkIfNullAttributePresent(subFilterSelectedItems) &&
                attributeTypeToShow.length === 1
            ) {
                previousAppliedGlobalFilter.current?.filter?.push(appliedGlobalFilter.current);
                previousAppliedGlobalFilter.current?.labels?.push(applyFilterObject?.attributeExId);
                previousAppliedGlobalFilter.current?.previousSelectedItem?.push(applyFilterObj.current);
                onSubFilterOptionsChange(
                    memoisedSubFilterDropdownOptions[tempAttributeIndex].value,
                    memoisedSubFilterDropdownOptions[tempAttributeIndex],
                    index,
                    appliedGlobalFilter.current,
                );
                applyFilterObj.current = applyFilterObject;
            } else {
                //when 2 attributetypes to show always reset applied  filter to global filter
                resetApplyFilterObj();
                applyFilterObj.current = applyFilterObject;
                previousAppliedGlobalFilter.current?.filter?.push(appliedGlobalFilter.current);
                previousAppliedGlobalFilter.current?.labels?.push(applyFilterObject?.attributeExId);
                previousAppliedGlobalFilter.current?.previousSelectedItem?.push(applyFilterObj.current);
                fetchAllSalesData();
            }
        },
        [memoisedSubFilterDropdownOptions, subFilterSelectedItems, attributeTypeToShow, variables, volTile],
    );

    //apply filter on complete
    function onApplyFilterComplete(payload: any) {
        // const tempApplyFilterResponse = _.cloneDeep(idForRestOfComponent);
        const tempGlobalFilter = appliedGlobalFilter.current
            ? JSON.parse(appliedGlobalFilter.current)
            : idForRestOfComponent;
        const tempApplyFilterResponse = _.cloneDeep(tempGlobalFilter);
        let commonIdsDim1 = [];
        let commonIdsDim2 = [];
        let commonIdsDim3 = [];
        if (payload?.dim1?.ids?.length > 0) {
            commonIdsDim1 = [...payload.dim1.ids];
            if (tempApplyFilterResponse.dim1.ids?.length > 0) {
                //if no id in global filter , it means all are selected
                commonIdsDim1 = _.intersection(tempApplyFilterResponse.dim1.ids, payload.dim1.ids);
            }
            tempApplyFilterResponse.dim1.ids = [...commonIdsDim1];
        }
        if (payload?.dim2?.ids?.length > 0) {
            commonIdsDim2 = [...payload.dim2.ids];
            if (tempApplyFilterResponse.dim2.ids?.length > 0) {
                //if no id in global filter , it means all are selected
                commonIdsDim2 = _.intersection(tempApplyFilterResponse.dim2.ids, payload.dim2.ids);
            }
            tempApplyFilterResponse.dim2.ids = [...commonIdsDim2];
        }
        if (payload?.dim3?.ids?.length > 0) {
            commonIdsDim3 = [...payload.dim3.ids];
            if (tempApplyFilterResponse.dim3?.ids?.length > 0) {
                //if no id in global filter , it means all are selected
                commonIdsDim3 = _.intersection(tempApplyFilterResponse.dim3.ids, payload.dim3.ids);
            }
            tempApplyFilterResponse.dim3.ids = [...commonIdsDim3];
        }
        const stringifiedApplyFilterResponse = JSON.stringify(tempApplyFilterResponse);

        appliedGlobalFilter.current = stringifiedApplyFilterResponse;
        setLoading(false);
        //if call coming from infinite scroll, redirect to infinite scroll function
        if (offsetRef.current.offset[0] !== commonConfig.offset) {
            return infiniteScrollerApplyFilterOnNext(stringifiedApplyFilterResponse, 0);
        } else if (offsetRef.current.offset[1] !== commonConfig.offset) {
            return infiniteScrollerApplyFilterOnNext(stringifiedApplyFilterResponse, 1);
        }
        //if length is 1 , comparison is not present and hence call only for 1st attribute type
        if (attributeTypeToShow.length === 1)
            updateVariablesAndExecuteQuery(
                attributeTypeToShow[0],
                fetchFirstLevelSales,
                stringifiedApplyFilterResponse,
            );
        //if length is 2 , comparison is present and hence call only for 2nd attribute type if call coming from same voltile
        else {
            //checking if call coming from same voltile
            if (previousVolTileRef.current?.key !== volTile.key) {
                updateVariablesAndExecuteQuery(attributeTypeToShow[0], fetchFirstLevelSales, undefined);
            }
            updateVariablesAndExecuteQuery(
                attributeTypeToShow[1],
                fetchSecondLevelSales,
                stringifiedApplyFilterResponse,
            );
        }
        previousVolTileRef.current = volTile;
    }

    //apply filter call
    function prepareApplyFilterVariableAndExecute() {
        const defaultApplyFilterGenerated = generateDefaultApplyFilter(idForRestOfComponent);
        const tempApplyFilterVairable: any = _.cloneDeep(defaultApplyFilterGenerated);
        if (applyFilterObj.current.dimension === 'dim1') {
            tempApplyFilterVairable.jsonstring_dim1.inclusion = [
                {
                    ...applyFilterObj.current,
                },
            ];
        } else if (applyFilterObj.current.dimension === 'dim2') {
            tempApplyFilterVairable.jsonstring_dim2.inclusion = [
                {
                    ...applyFilterObj.current,
                },
            ];
        } else {
            tempApplyFilterVairable.jsonstring_dim3.inclusion = [
                {
                    ...applyFilterObj.current,
                },
            ];
        }
        tempApplyFilterVairable.jsonstring_dim1 = JSON.stringify(tempApplyFilterVairable.jsonstring_dim1);
        tempApplyFilterVairable.jsonstring_dim2 = JSON.stringify(tempApplyFilterVairable.jsonstring_dim2);
        tempApplyFilterVairable.jsonstring_dim3 = JSON.stringify(tempApplyFilterVairable?.jsonstring_dim3 || '{}');
        tempApplyFilterVairable.jsonstring_dim4 = JSON.stringify(tempApplyFilterVairable?.jsonstring_dim4 || '{}');
        applyFilterMutate({ variables: tempApplyFilterVairable });
    }

    const renderBaseLinePeriodLabel = () => {
        if (
            !comparePeriodEnabled ||
            selectedTimePeriodDropdown?.value === 'custom' ||
            !comparisonTimePeriod ||
            firstLevelSaleLoading
        )
            return null;

        const daysDifference = frequencyDaysMapping[currentFrequency?.key ?? 'W'] ?? 0;
        const startDate = dayjs
            .unix(comparisonTimePeriod?.startTimestamp)
            .add(daysDifference, 'day')
            .utc()
            .format(commonConfig.dateFormat);
        const endDate = dayjs
            .unix(comparisonTimePeriod?.endTimestamp)
            .add(daysDifference, 'day')
            .utc()
            .format(commonConfig.dateFormat);

        return (
            <div className="w-[180px]">
                <CalenderPriceChange
                    position="bottom"
                    setStartDate={() => {}}
                    setEndDate={() => {}}
                    startDate={startDate}
                    endDate={endDate}
                    calenderHeader={''}
                    isDisabled
                />
            </div>
        );
    };

    useEffect(() => {
        if (timePeriodSelection && !allDimAndAttributeTypeList?.loading) fetchAllSalesData();
        //update voltile data
        if (!(attributeTypeToShow?.length === 2 && applyFilterObj.current)) {
            previousVolTileRef.current = volTile;
        }
    }, [attributeTypeToShow, salesTile, volTile, stringifiedGlobalFilter, timePeriodSelection, variables]);

    return (
        <>
            {/* SUB FILTER CONTAINER */}
            <div className="flex gap-2 mb-4 overflow-x-auto">
                {subFilterSelectedItems.map((item, index) => {
                    return (
                        <div key={index} className="flex gap-2 items-center">
                            <SubFilterDropdown
                                loading={
                                    allDimAndAttributeTypeList?.loading ||
                                    timePeriodLoading ||
                                    salesDataset[0].loading ||
                                    salesDataset[1].loading ||
                                    false
                                }
                                onChange={onSubFilterOptionsChange}
                                key={index}
                                index={index}
                                options={memoisedSubFilterDropdownOptions}
                                value={item.label}
                                from="growth-analysis"
                            />
                            {subFilterSelectedItems?.length - 1 !== index && (
                                <SubFilterCompareIcon
                                    disabled={
                                        subFilterSelectedItems[index + 1]?.label === null ||
                                        salesDataset[0].loading ||
                                        salesDataset[1].loading
                                    }
                                    onClick={compareSubFilterClickHandler}
                                    index={index}
                                    active={activeCompareIcons.includes(index)}
                                />
                            )}
                        </div>
                    );
                })}
            </div>

            {/* GROWTH ANALYSIS CONTAINER */}
            <div
                className={`border border-borderLinePurpule bg-white p-4  rounded-lg            
            `}
            >
                {filterNullError ? (
                    <NoDataForSelection />
                ) : (
                    <div>
                        <div className="flex justify-between items-center mb-4">
                            <div className="flex items-center">
                                <h2 className="font-medium font-xl m-0 text-headerColor">
                                    {isDepletion ? 'Depletion Analysis' : growthAnalysisHeader}
                                </h2>
                                {!isDepletion && attributeTypeToShow.length < 2 && (
                                    <TileButton
                                        disabled={salesDataset[0].loading || salesDataset[1].loading}
                                        data={salesTileData}
                                        activeKey={salesTile.key}
                                        onClick={(item: any) => {
                                            setSalesTile(item);
                                            //mixpanel event
                                            trackEventMixpanel(GROWTH_ANALYSIS_SALES_TAB_CHANGED, {
                                                tabName: item?.label,
                                            });
                                        }}
                                        style={{ marginLeft: 16 }}
                                    />
                                )}
                            </div>
                            <div className="flex justify-between items-center">
                                <h5 className="font-medium font-xs m-0 !text-fontGray mr-3">Metric</h5>
                                <CustomSelect
                                    style={{ marginRight: 16 }}
                                    suffixIcon={<DownSvg />}
                                    disabled={false}
                                    //loading={allDimAndAttributeTypeList?.loading}
                                    value={volTile.key}
                                    options={salesTile?.key === 'depletion' ? depletionDropdownData : volTileData}
                                    className="dropdown-height dropdown-width-alt uniqSelGrowthAnalysisDropdown"
                                    onChange={(val: any, item: any) => {
                                        setVolTile(item);
                                        //mixpanel event
                                        trackEventMixpanel(GROWTH_ANALYSIS_UNIT_DROPDOWN_CHANGED, {
                                            selectedDropdown: item?.label,
                                        });
                                    }}
                                />
                                <TileButton
                                    data={absTileData}
                                    activeKey={absTile.key}
                                    onClick={(item: any) => {
                                        setAbsTile(item);
                                        //mixpanel event
                                        trackEventMixpanel(GROWTH_ANALYSIS_ABS_TAB_CHANGED, {
                                            tabName: item?.label,
                                        });
                                    }}
                                    // style={{ marginRight: 16 }}
                                />
                                {/* <TileButton
                                    data={volTileData}
                                    activeKey={volTile.key}
                                    onClick={(item: any) => setVolTile(item)}
                                /> */}
                                {showTotal && !isDepletion && (
                                    <Dropdown
                                        className="ml-4"
                                        menu={{
                                            items: [
                                                {
                                                    key: 'showTotals',
                                                    label: (
                                                        <div className="flex items-center gap-2">
                                                            <Checkbox checked={showTotals} />
                                                            <span>Show Totals</span>
                                                        </div>
                                                    ),
                                                    onClick: () => setShowTotals((prev) => !prev),
                                                },
                                            ],
                                        }}
                                        trigger={['click']}
                                        placement="bottomRight"
                                    >
                                        <button
                                            className="flex items-center justify-center border border-borderLinePurpule rounded-md cursor-pointer bg-white hover:border-purpleFont hover:text-purpleFont transition-colors"
                                            style={{ width: 32, height: 32 }}
                                        >
                                            <EllipsisOutlined style={{ fontSize: 18 }} />
                                        </button>
                                    </Dropdown>
                                )}
                            </div>
                        </div>

                        {comparePeriodEnabled && timePeriodOptions && (
                            <div className="flex justify-between mb-4">
                                <div className="flex items-end gap-4">
                                    <div>
                                        <p className="text-greyFont font-medium pb-1 font-xs">{baseLinePeriodLabel}</p>
                                        <CustomSelect
                                            className="dropdown-height dropdown-width-multi-select uniqSelGABaseLinePeriodDropdown"
                                            suffixIcon={<DownSvg />}
                                            value={selectedTimePeriodDropdown?.value}
                                            disabled={false}
                                            options={comparePeriodOptions}
                                            onChange={(val: any, item: any) => {
                                                setSelectedTimePeriodDropdown(item);
                                            }}
                                        />
                                    </div>
                                    {selectedTimePeriodDropdown?.value === 'custom' ? (
                                        <div className="w-[180px]">
                                            <CalenderPriceChange
                                                position="bottom"
                                                setStartDate={setSecondStartRange}
                                                setEndDate={setSecondEndRange}
                                                startDate={secondStartRange}
                                                endDate={secondEndRange}
                                                resetOnGlobalTimePeriodChange={comparePeriodEnabled}
                                                calenderHeader=""
                                                deriveEndFromDurationSeconds={
                                                    useDerivedCompareCustomEnd
                                                        ? comparePeriodDurationSeconds
                                                        : undefined
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <>{renderBaseLinePeriodLabel()}</>
                                    )}
                                </div>
                            </div>
                        )}

                        {allDimAndAttributeTypeList?.loading || timePeriodLoading ? (
                            <div className="h-[60vh] ">
                                <Loader />
                            </div>
                        ) : comparePeriodEnabled &&
                          selectedTimePeriodDropdown?.value === 'custom' &&
                          (useDerivedCompareCustomEnd
                              ? secondStartRange === ''
                              : secondStartRange === '' || secondEndRange === '') ? (
                            <div>
                                <ErrorBox msg="enterDateRange" />
                            </div>
                        ) : (
                            attributeTypeToShow.map((item, index) => {
                                return (
                                    <div key={item.key} className="flex">
                                        {/* MAKE SURE TO MEMOIZE FUNCTIONS AND VARIABLES */}
                                        <ExpandedView
                                            from={from}
                                            stringifiedFilter={appliedGlobalFilter.current}
                                            previousApplyFilter={previousAppliedGlobalFilter.current}
                                            drillDownSelectedData={applyFilterObj.current}
                                            attributeTypeItems={attributeTypeToShow}
                                            attributeTypeItem={item}
                                            index={index}
                                            absTile={absTile}
                                            volTile={volTile}
                                            salesTileData={salesTileData}
                                            salesTile={salesTile}
                                            drillDownHandler={drillDownHandler}
                                            dropdownItems={memoisedSubFilterDropdownOptions}
                                            dropdownClickHandler={barChartRightClickHandler}
                                            attrTypeOptions={attrTypeOptions}
                                            salesDataset={salesDataset}
                                            infiniteScrollerOnNext={infiniteScrollerOnNext}
                                            infiniteScrollSettings={offsetRef.current}
                                            timePeriod={variables.timePeriod}
                                            comparePeriodEnabled={comparePeriodEnabled}
                                            comparisonPeriodType={variables.comparisonPeriodType}
                                            selectedTimePeriodDropdownValue={selectedTimePeriodDropdown?.value}
                                            customTimePeriod={[secondStartRange, secondEndRange]}
                                            showTotals={effectiveShowTotals}
                                        />
                                    </div>
                                );
                            })
                        )}

                        {/* <SelectionBadge /> */}
                    </div>
                )}
            </div>
        </>
    );
};

export default GrowthAnalysis;
